import { render, staticRenderFns } from "./DialogController.vue?vue&type=template&id=4d09efed"
import script from "./DialogController.vue?vue&type=script&lang=ts"
export * from "./DialogController.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports